import React, { useState, useEffect } from "react";
import ImageCard from "../../atoms/ImageCard";
import Button from "../../atoms/Button";
import { Link } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { ReactComponent as CloseBtn } from "../../svgs/close.svg";
import NotificationDialog from "../../molecules/NotificationDialogBox";
import Badge from "../Badge";
import { addWishlist } from "../../../utils/API/addToWishlist";
import {
  addToWishlist,
  removeFromWishlist
} from "../../../redux/slices/wishlist-slice";
import AcceptPopUp from "../../molecules/AcceptPopUp";
import { deleteWishlistItem } from "../../../utils/API/deleteWishlist";
import toast from "react-hot-toast";
import AddMoreRequest from "../AddMoreRequest";
import { Tooltip } from "antd";
import { getRegistryImage } from "../../../utils/helper/getRegistryImage";

const ProjectCard = ({
  closeBtn = false,
  actionButton = true,
  _id,
  project: {
    _id: projectId,
    blockchain_detail,
    projectName,
    tokenType,
    location: { country, state },
    ogScore = 30,
    SDG_contribution,
    typeOfCredit,
    cover_image,
    categoryDetails: { categoryName },
    subCategoryDetails: { subCategoryName },
    registryDetails: { registryName }
  },
  userData: { userId, userName },
  numberOfCredits: numberOfCredits,
  no_of_credits_to_sell = "0",
  projectImage = "/images/projectone.png",
  price_per_credit = "2",
  isListed = true,
  credit_transaction,
  bidHandler,
  isProjectDescription = false,
  InquireHandler,
  setBidNotNotificationDialogState
}) => {
  const localRegistryImage = getRegistryImage(registryName);

  const onBidClick = (e) => {
    e.preventDefault();
    e.stopPropagation();
    if (!userType) {
      SetUserNOtFoundDailog(true);
    } else if (
      userType === "trader" &&
      (typeOfCredit === "retireable" || typeOfCredit === "non-transferable")
    ) {
      setBidNotNotificationDialogState(true);
    } else {
      bidHandler(`/bid?projectId=${projectId}&userId=${userId}`);
    }
  };

  const onInquireClick = async (e) => {
    e.preventDefault();
    e.stopPropagation();
    const formData = {
      projectId: projectId,
      creditOwner: userId
    };
    // console.log("onInquireClick formData:", formData);
    InquireHandler(formData);
  };

  const [notificationDialogState, setNotificationDialogState] = useState(false);
  const dispatch = useDispatch();
  const { userType } = useSelector((state) => state.authReducer);
  const [isWishlistClicked, setIsWishlistClicked] = useState(null);
  const [wishlistUnavailable, setWishlistUnavailable] = useState(false);
  const [projects, setProjects] = useState(false);
  const [userNotFoundDailog, SetUserNOtFoundDailog] = useState(false);
  const [addMoreRequest, setAddMoreRequest] = useState(false);

  const wishlist = useSelector((state) => state.wishlist);

  useEffect(() => {
    if (wishlist) {
      const isProjectInWishlist = wishlist.find(
        (item) =>
          item.holdingsId === _id && item.is_enquire_required !== isListed
      );
      setIsWishlistClicked(isProjectInWishlist);
    }
  }, [wishlist, _id]);

  const handleWishlistClick = async (e) => {
    e.preventDefault();
    e.stopPropagation();

    if (!userType) {
      SetUserNOtFoundDailog(true);
      return;
    }

    if (isWishlistClicked) {
      handleRemoveFromWishlist();
    } else {
      try {
        const additionalParams = { holdingsId: _id, credit_owner: userId };
        if (isListed) {
          additionalParams.is_enquire_required = false;
        } else {
          additionalParams.is_enquire_required = true;
        }
        const result = await addWishlist(additionalParams, dispatch);
        if (result.success) {
          dispatch(addToWishlist(result.data));
          setIsWishlistClicked(result.data);
        } else {
          console.error("Failed to add to wishlist:", result.message);
        }
      } catch (error) {
        console.error("Error adding project to wishlist:", error);
      }
    }
  };

  const handleRemoveFromWishlist = async () => {
    try {
      await deleteWishlistItem(isWishlistClicked._id, dispatch);
      dispatch(removeFromWishlist({ id: isWishlistClicked._id }));
      setIsWishlistClicked(null);
    } catch (error) {
      console.error("Failed to delete wishlist item:", error);
    }
  };

  const handleVerifyClick = () => {
    if (blockchain_detail.length > 0 &&blockchain_detail[0] && blockchain_detail[0].transaction_signature) {
      window.open(
        `https://explorer.solana.com/tx/${blockchain_detail[0].transaction_signature}?cluster=mainnet-beta`,
        "_blank",
        "noopener,noreferrer"
      );
    } else {
      toast.error("BlockChain Details Not Found");
    }
  };

  const handleAddMoreCredits = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setAddMoreRequest(true);
  };

  return (
    <>
      {" "}
      <Link
        to={`/project-details?projectId=${projectId}&userId=${userId}&inquire=${!isListed}`}
      >
        {!isProjectDescription && (
          <div className="flex flex-row bg-white rounded-2xl h-24">
            <div className="ml-1 my-1 relative">
              <ImageCard
                iconDisplay="flex"
                classnames="w-[11rem] h-full bg-cover"
                userImage={cover_image}
              />
              <div
                className="absolute top-[0px] right-[0px] w-28  bg-white h-4 rounded-bl-md text-[8px] flex gap-1"
                onClick={handleVerifyClick}
              >
                <p className=" text-blue-800 font-bold pl-2">
                  Verify on BlockChain
                </p>
                <svg
                  class="h-3 w-3 text-blue-800"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  stroke-width="2"
                  stroke="currentColor"
                  fill="none"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                >
                  {" "}
                  <path stroke="none" d="M0 0h24v24H0z" />{" "}
                  <line x1="17" y1="7" x2="7" y2="17" />{" "}
                  <polyline points="8 7 17 7 17 16" />
                </svg>
              </div>
              <div className="absolute bottom-[0px] left-[0px] p-0 bg-white rounded-tr-lg">
                {tokenType === "Gold" && (
                  <img
                    src="images/GoldTokens.png"
                    alt="Gold Token"
                    style={{ width: "40px", height: "40px" }}
                  />
                )}
                {tokenType === "Silver" && (
                  <img
                    src="images/SilverTokens.png"
                    alt="Silver Token"
                    style={{ width: "40px", height: "40px" }}
                  />
                )}
                {tokenType === "Bronze" && (
                  <img
                    src="images/BronzeTokens.png"
                    alt="Bronze Token"
                    style={{ width: "40px", height: "40px" }}
                  />
                )}
              </div>
            </div>
            <div className="flex  w-full justify-between ">
              <div className="ml-4 p-2 flex flex-col justify-between">
                <div className="flex flex-row ">
                  <h1 className="w-fit text-lg shrink-0 font-black">
                    {projectName}
                  </h1>

                  <div
                    className="w-12 h-12 ml-2 "
                    style={{
                      background: `top / contain no-repeat url(${localRegistryImage})`
                    }}
                  >
                    {/* <img className="w-full h-full" src={registryImage} alt={"registry"} /> */}
                  </div>
                </div>

                <h2 className="text-xs h-fit w-fit">{`${state}, ${country}`}</h2>
                <div className="text-[10px]">
                  {isListed ? (
                    <div>
                      <span className="font-bold">
                        Listed Credits - {no_of_credits_to_sell} |
                      </span>
                      <span className="font-medium">
                        {" "}
                        Total Credits - {numberOfCredits} |
                      </span>
                      <span className=" capitalize">
                        {` ${credit_transaction} `}|
                      </span>
                      <span className=" capitalize">
                        {" "}
                        {` ${typeOfCredit} `}|
                      </span>
                      { no_of_credits_to_sell < numberOfCredits  && 
                      <Tooltip
                        title={
                          "Seller has more credit in the holding than listed credits, if you want to buy more click here"
                        }
                      >
                        <span
                          className="text-sm  text-blue-800"
                          onClick={onInquireClick}
                        >
                          {" "}
                          More credits ?
                        </span>
                      </Tooltip>}
                    </div>
                  ) : (
                    <h3>
                      <span className="font-medium">
                        {" "}
                        Total Credits - {numberOfCredits} |
                      </span>
                      <span style={{textTransform: 'capitalize'}}> {typeOfCredit}</span>
                    </h3>
                  )}
                </div>
              </div>
              <div className="pt-2 pr-4 flex flex-col">
                {closeBtn && <CloseBtn className="w-4 self-end" />}
                <div className="text-blue-200 text-right">
                  <div className="flex justify-end gap-3">
                    <h1 className="text-[8px] lg:text-[10px] lg:font-light text-blue-800 ">
                      {categoryName}
                    </h1>
                    {!isWishlistClicked ? (
                      <img
                        src="images/wishlist.svg"
                        alt="wishlist-icon"
                        onClick={handleWishlistClick}
                      />
                    ) : (
                      <img
                        src="images/checkedWishlist.svg"
                        alt="checked-wishlist-icon"
                        onClick={handleWishlistClick}
                      />
                    )}
                  </div>
                  <h2 className="text-xs font-bold mt-1 text-blue-800">
                    OG Score - {ogScore}
                  </h2>
                </div>

                {(isListed && Number(no_of_credits_to_sell) > 0 ) ? (
                  <h3 className="text-xl sm:text-xs md:text-sm mt-1 font-medium text-right flex items-center whitespace-nowrap">
                    $ {price_per_credit} per Credits
                    {actionButton && (
                      <span className="ml-4 block">
                        <Button
                          varient="primary"
                          borderColor="blue"
                          className="px-10 py-2 text-sm text-white bg-blue-800"
                          onClick={onBidClick}
                        >
                          Bid
                        </Button>
                      </span>
                    )}
                  </h3>
                ) : (
                  <h3 className="text-xl mt-2 font-medium flex items-center">
                    <>
                      <span className="text-[10px] text-blue-800 font-medium">
                        This Project is not Listed
                      </span>
                      {actionButton && (
                        <span className="ml-4 block">
                          <Button
                            onClick={onInquireClick}
                            varient="primary"
                            borderColor="none"
                            className="px-7 py-2 text-sm text-blue-800 bg-blue-300 "
                          >
                            Inquire
                          </Button>
                        </span>
                      )}
                    </>
                  </h3>
                )}
              </div>
            </div>
          </div>
        )}
        {isProjectDescription && (
          <div className="flex flex-row   bg-white rounded-2xl py-1 border-b border-grey-200 shadow-md">
            <div className="ml-1 my-1 relative">
              <ImageCard
                iconDisplay="flex"
                classnames="w-[8rem] h-[4.2rem] bg-cover"
                userImage={cover_image}
              />
              <div className="absolute bottom-[4px] left-[6px] rounded-tr-lg">
                <Badge varient={tokenType}>
                  <div className="flex justify-center text-white items-center font-normal w-7 text-[9px]">
                    {tokenType}
                  </div>
                </Badge>
              </div>
            </div>
            <div className="flex  w-full justify-between ">
              <div className="ml-4 w-full flex flex-col justify-between">
                <div className="flex flex-col w-full ">
                  <div
                    className="w-12 h-6 "
                    style={{
                      background: `top / contain no-repeat url(${localRegistryImage})`
                    }}
                  ></div>

                  <div className="flex">
                    <h1 className=" text-[10px] truncate font-black">
                      {projectName}
                    </h1>{" "}
                    <h1 className="text-[12px] xl:text-[12px]  md:text-[8px] pl-1 ">{`${state}, ${country}`}</h1>
                  </div>
                </div>

                <div className="text-[10px]">
                  {isListed ? (
                    <h3>
                      <span className="font-bold">
                        {no_of_credits_to_sell} Credits
                      </span>
                    </h3>
                  ) : (
                    <h3>
                      <span className="font-medium">
                        {" "}
                        Total Credits - {numberOfCredits}
                      </span>
                    </h3>
                  )}
                </div>
              </div>
            </div>
          </div>
        )}
      </Link>
      <AcceptPopUp
        open={userNotFoundDailog}
        statusType={
          <span className="text-base font-semibold">
            "To buy Carbon credit sign in with buyer or traders account !!"
          </span>
        }
        onCancel={() => SetUserNOtFoundDailog(false)}
        okButtonText={"Log-in/Sign-up"}
        isRequiredCancelButton={false}
      />
      <AcceptPopUp
        open={wishlistUnavailable}
        statusType={
          <span className="text-base font-semibold">
            "To wishlist this Carbon credit sign in with buyer or trader
            account!"
          </span>
        }
        onCancel={() => setWishlistUnavailable(false)}
        okButtonText={"Ok"}
        onOk={() => setWishlistUnavailable(false)}
        isRequiredCancelButton={false}
      />
      {addMoreRequest && (
        <AddMoreRequest
          open={addMoreRequest}
          onCancel={() => setAddMoreRequest(false)}
        />
      )}
    </>
  );
};
export default ProjectCard;
